module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Administração")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isAdminRequests) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/requests",
      "id": "admin-requests"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-duplicate"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Requisições")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminRequestTypes) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/requestTypes",
      "id": "admin-request-types"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-list-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Tipos de Requisição")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminWorkflows) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/workflows",
      "id": "admin-workflows"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-in"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Workflows")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminGroups) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/groups",
      "id": "admin-groups"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-th-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Grupos")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminUsers) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/users",
      "id": "admin-users"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Usuários")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.isAdminRequests && !_vm.isAdminRequestTypes && !_vm.isAdminWorkflows && !_vm.isAdminGroups) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      Nenhum privilégio de administrador encontrado.\n  ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a55c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management.vue
// module id = 1450
// module chunks = 1